// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListImageVideoCardStyles } from "@west/App/Components/ProductList/ProductListImageVideoCard";
import { css } from "styled-components";

productListImageVideoCardStyles.wrapper = {
    width: [12, 6, 6, 4, 4],
    css: css`
        position: relative;
    `,
};

productListImageVideoCardStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: 100%;
        object-fit: cover;
    `,
};

productListImageVideoCardStyles.video = {
    container: {
        css: css`
            height: 100%;

            video {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        `,
    },
};

productListImageVideoCardStyles.playPauseIcon = {
    color: "common.ui1",
    css: css`
        position: absolute;
        cursor: pointer;
        ${({ isVideoPlaying }: any) =>
            isVideoPlaying
                ? css`
                      width: 12px;
                      height: 12px;
                      right: 26px;
                      bottom: 26px;
                  `
                : css`
                      right: 20px;
                      bottom: 20px;
                  `}
    `,
};
